import type { CSSProperties } from 'react';
import { Alert, Collapse } from '@ksyos/design-system';
import { useNavigate } from '@ksyos/router';
import { useState } from 'react';

export interface ITwoFactorAuthenticationAlertProps {
    hasIcon?: boolean;
    practitionerId: string;
    style?: CSSProperties;
}

export function TwoFactorAuthenticationAlert({ practitionerId, style, hasIcon }: ITwoFactorAuthenticationAlertProps) {
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState<boolean>(false);

    return (
        <Alert
            appearance="warning"
            hasIcon={hasIcon}
            style={{
                ...style,
                flexShrink: 0,
            }}
        >
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        maxWidth: '850px',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        width: '100%',
                    }}
                >
                    <Alert.Text
                        fontWeight="bold"
                        mb={2}
                    >
                        Stel nu tweestapsverificatie in, voorkom dat je niet meer kunt inloggen
                    </Alert.Text>
                    <Alert.Text>
                        Om aan de richtlijnen van de AVG te voldoen zijn wij verplicht om gebruikers met
                        tweestapsverificatie te laten inloggen. Stel het nu in, zodat je gebruik kunt blijven maken van
                        het Ksyos platform.
                    </Alert.Text>
                    <Alert.Link
                        fontWeight="normal"
                        iconLeft={isOpen ? 'caret-up' : 'caret-down'}
                        my={4}
                        onClick={() => setIsOpen(!isOpen)}
                        size="sm"
                        variant="button"
                    >
                        Wat als ik via het HIS of OptoConnect inlog?
                    </Alert.Link>
                    <Collapse isOpen={isOpen}>
                        <Alert.Text>
                            Als je via het HIS of OptoConnect inlogt kun je direct naar Ksyos zoals je gewend bent. Het
                            is alleen niet meer mogelijk zonder tweestapsverificatie in te loggen via www.ksyos.nl na 1
                            november.
                        </Alert.Text>
                    </Collapse>
                </div>
                <Alert.Button
                    onClick={() => navigate(`/practitioners/${practitionerId}/profile/security`)}
                    style={{ maxWidth: '100%' }}
                >
                    Stel tweestapsverificatie in
                </Alert.Button>
            </div>
        </Alert>
    );
}
